import PropertyComponent from "../Components/AllProperties";
import bgImg from "../Assets/Images/property3.jpg";

export default function Properties() {
  return (
    <div>
      <div className="relative bg-secondaryx h-96">
        <img alt="Background"
          className="absolute inset-0 w-full h-full object-cover mix-blend-overlay"
          src={bgImg}
        />
        <div className="absolute inset-0 bg-secondaryx bg-opacity-75"></div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Our properties
          </h1>
          <p className="mt-6 text-xl text-blue-100 max-w-3xl">
            Comprehensive real estate solutions driving value and innovation
            across Africa
          </p>
        </div>
      </div>

      <PropertyComponent />
    </div>
  );
}